
import React, { useState, useEffect , useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { FiTrash2, FiDownload, FiFileText } from 'react-icons/fi';
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import LocationPicker from "../LocationPicker";

const center = {
  lat: 40.0853,
  lng: 22.3584,
};


const Container = styled.div`
  margin: 50px;
  padding: 2rem;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  border-radius: 8px;
 
  @media (max-width: 768px) {
   text-align:center;
  }

`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

    @media (max-width: 768px) {
    flex-direction:column;
    gap:25px;
  }
`;

const Title = styled.h2`
  color: #385963;
`;

const BackButton = styled.button`
  background: none;
  border: 1px solid #385963;
  color: #385963;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background-color: #f0f0f0;
  }

   @media (max-width: 768px) {
    font-size:10px;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const FieldWrapper = styled.div``;

const FieldTitle = styled.h4`
  margin-bottom: 1rem;
  color: #385963;
`;

const LangRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LocationRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FieldGroup = styled.div`
  margin-bottom: 1.5rem;

  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #385963;
  }

  input, textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
  }

  textarea {
    resize: vertical;
    min-height: 100px;
  }
`;

const Button = styled.button`
  background-color: #385963;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 2rem;
  place-self: center;

  &:hover {
    background-color: #2c4a52;
  }
`;

const DeleteButton = styled.button`
  background-color: #ff4d4d;  /* Red background */
  color: white;
  border: none;
  padding: 0.5rem 1rem;  /* Smaller padding */
  font-size: 0.9rem;      /* Smaller font size */
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
  
  &:hover {
    background-color: #e60000;  /* Darker red on hover */
  }
`;

const ModalImage = styled.img`
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
`;

const PhotoGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const PhotoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img{
    border-radius: 5px;
  }

    @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
  
`;


const SinglePhotoContainer = styled.div`
  display: flex;
  flex-direction:column;
  align-items: center;
  margin-top: 10px;

  img{
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  background-color: white;
  color: #385963;

  &:focus {
    border-color: #385963;
    outline: none;
    box-shadow: 0 0 0 2px rgba(56, 89, 99, 0.2);
  }

  option {
    color: #385963;
  }
`;


const FileListContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const FileCard = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  gap: 50px;
  background: #f8f9fa;
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 12px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  margin-right: 20px;

  svg {
    color: #385963;
    font-size: 20px;
  }

  span {
    font-weight: 500;
    color: #333;
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

const FileActions = styled.div`
  display: flex;
  gap: 10px;

  button, a {
    display: flex;
    align-items: center;
    // gap: 5px;
    background: none;
    border: none;
    color: #385963;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.2s ease;

    svg {
      font-size: 18px;
    }

    &:hover {
      background-color: #d6e4e9;
      color: #2e4852;
    }
  }

  button.delete {
    color: #e74c3c;

    &:hover {
      background-color: #f9d6d5;
      color: #c0392b;
    }
  }

   @media (max-width: 768px) {
       gap: 10px;
        button, a {
          padding: 2px
        }
    }
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.visible ? 'auto' : 'none')};
  transition: visibility 0.3s ease;
`;


// FilePlaceTypeEnum
const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
   Documents: 4, 
};

const EditAmenity = () => {


  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem("token");
  const { id } = useParams();
  const { t , i18n } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [categories, setCategories] = useState([]);
  const filesInputRef = useRef(null);
  const modalCleanupRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const [filesToDelete, setFilesToDelete] = useState([]); // existing files
  const [filesToRemoveFromUpload, setFilesToRemoveFromUpload] = useState([]); // new files removed before submit


  // Initialize form with default structure to avoid undefined errors
  const [form, setForm] = useState({
    name: { gr: '', en: '' },
    description: { gr: '', en: '' },
    location: { latitude: '', longitude: '' },
    categoryId: '',
    phone: '',       // new
    email: '',       // new
    websiteUrl: '',
    providerId: '',  // new
    coverPhoto: null,
    categoryPhoto: null,
    posterPhoto: null, 
    photos: [],
    existingCoverFileName: null,
    existingCategoryFileName: null,
    existingPosterFileName: null, 
    // Add existing photos filenames if needed to handle delete on server
    existingGalleryFileNames: [], // optional
    posterBase64Src: null,
    otherFiles: [],  // New files to upload
  existingOtherFiles: [],
  });


  const { isLoaded } = useLoadScript({
      googleMapsApiKey: "AIzaSyCIrKrxTVDqlcRVFNyNMm5iS869G7RYvuc",
      libraries: ["places"],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${BASE_URL}Amenity/${id}`, {
          headers: {
            Authorization: `Bearer ${tokenString}`,
          },
        });
        if (!response.ok) throw new Error("Failed to fetch Amenity data");
        const data = await response.json();
        const rawFileNames = data.fileNames; 
        let fetchedFiles = [];

      if (rawFileNames.length > 0) {
        const fileResponse = await fetch(`${BASE_URL}Amenity/getFiles`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${tokenString}`,
          },
          body: JSON.stringify( rawFileNames),
        });

        if (!fileResponse.ok) throw new Error("Failed to fetch file contents");
        fetchedFiles = await fileResponse.json();
      }

      // Process fetched files based on their filePlaceType
      const {
        existingCoverFileName,
        existingCategoryFileName,
        existingGalleryFileNames, 
        existingPosterFileName,
        galleryBase64Srcs,
        coverBase64Src,
        categoryBase64Src,
        posterBase64Src, 
         existingOtherFiles 
      } = processFiles(fetchedFiles);

      setForm({
       name: data.name || { gr: '', en: '' },
       description: data.description || { gr: '', en: '' },
       location: data.location || { latitude: '', longitude: '' },
       categoryId: data.categoryId || '',
       phone: data.phone || '',
       email: data.email || '',
       websiteUrl: data.websiteUrl || '',
       providerId: '', // <-- will be updated once matched
       providerName: data.providerName || '',
       coverPhoto: null,
       categoryPhoto: null,
       photos: [],
       existingCoverFileName,
       existingCategoryFileName,
       existingGalleryFileNames,
       galleryBase64Srcs,
       coverBase64Src,
       categoryBase64Src,
       posterPhoto: null, 
       existingPosterFileName,
       posterBase64Src,
        existingOtherFiles 
     });

      } catch (err) {
        console.error('Error loading Amenity:', err);
      }
       finally {
          setIsLoading(false); // End loading
        }
    };
    fetchData();
  }, [BASE_URL, id, tokenString]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}AmenityCategory`);
        if (!response.ok) throw new Error("Failed to fetch categories");
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Error fetching Categories:', error);
      }
    };
    fetchCategories();
  }, [BASE_URL]);


const uploadFiles = async (id, files, types) => {

 const formData = new FormData();
 
 for (let i = 0; i < files.length; i++) {
   // Append the file name (string)
   formData.append('uploadFiles', files[i]);
 
   // Append the corresponding file type
   formData.append('uploadFileTypes', types[i].toString());
 }

  try {
    const response = await fetch(`${BASE_URL}Amenity/${id}/uploadFiles`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${tokenString}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Upload failed:', errorText);
      throw new Error(errorText);
    }

  } catch (error) {
    console.error('Upload error:', error);
  }
};



const processFiles = (files) => {
  const coverFile = files.find(f => f.filePlaceType === FILE_PLACE_TYPE.CoverPhoto);
  const categoryFile = files.find(f => f.filePlaceType === FILE_PLACE_TYPE.CategoryPhoto);
  const galleryFiles = files.filter(f => f.filePlaceType === FILE_PLACE_TYPE.Gallery);
  const posterFile = files.find(f => f.filePlaceType === FILE_PLACE_TYPE.Poster);



  const coverBase64Src = coverFile ? `data:${coverFile.mimeType};base64,${coverFile.base64Content}` : null;
  const categoryBase64Src = categoryFile ? `data:${categoryFile.mimeType};base64,${categoryFile.base64Content}` : null;
  const galleryBase64Srcs = galleryFiles.map(f => `data:${f.mimeType};base64,${f.base64Content}`);
  const posterBase64Src = posterFile ? `data:${posterFile.mimeType};base64,${posterFile.base64Content}` : null;

  // Collect filenames of gallery files to handle deletions later
  const existingGalleryFileNames = galleryFiles.map(f => f.fileName);

    const otherFiles = files.filter(
    (f) =>
      f.filePlaceType !== FILE_PLACE_TYPE.CoverPhoto &&
      f.filePlaceType !== FILE_PLACE_TYPE.CategoryPhoto &&
      f.filePlaceType !== FILE_PLACE_TYPE.Gallery &&
      f.filePlaceType !== FILE_PLACE_TYPE.Poster
  );

  const existingOtherFiles = otherFiles.map(f => ({
    fileName: f.fileName,
    mimeType: f.mimeType,
    base64Content: f.base64Content,
  }));


  return {
    existingCoverFileName: coverFile?.fileName || null,
    existingCategoryFileName: categoryFile?.fileName || null,
    existingPosterFileName: posterFile?.fileName || null,
    existingGalleryFileNames,  
    galleryBase64Srcs,
    coverBase64Src,
    categoryBase64Src,
    posterBase64Src,
    existingOtherFiles
  };
};


  const deleteFiles = async (id, fileNames) => {
    try {
      const response = await fetch(`${BASE_URL}Amenity/${id}/deleteFiles`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenString}`,
        },
        body: JSON.stringify(fileNames),
      });

      if (!response.ok) throw new Error('Failed to delete files');
    } catch (error) {
      console.error('Delete error:', error);
    }
  };

  const handleChange = (field, value, lang = null) => {
    if (lang) {
      setForm(prev => ({
        ...prev,
        [field]: {
          ...prev[field],
          [lang]: value,
        },
      }));
    } else {
      setForm(prev => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleFileChange = (e, isMultiple, field) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    if (isMultiple) {
      setForm(prev => ({
        ...prev,
        photos: [...prev.photos, ...Array.from(files)],
      }));
    } else if (field) {
      setForm(prev => ({
        ...prev,
        [field]: files[0],
      }));
    }
  };

  const handleDeleteCoverPhoto = () => {
  if (form.existingCoverFileName) {
    setFilesToDelete(prev => [...prev, form.existingCoverFileName]);
  }
  setForm(prev => ({
    ...prev,
    coverPhoto: null,
    coverBase64Src: null,
    existingCoverFileName: null,
  }));
};

const handleDeleteExistingGalleryPhoto = (index) => {
  const fileName = form.existingGalleryFileNames[index];
  setFilesToDelete(prev => [...prev, fileName]);

  setForm(prev => {
    const newGalleryBase64Srcs = [...prev.galleryBase64Srcs];
    newGalleryBase64Srcs.splice(index, 1);

    const newExistingGalleryFileNames = [...prev.existingGalleryFileNames];
    newExistingGalleryFileNames.splice(index, 1);

    return {
      ...prev,
      galleryBase64Srcs: newGalleryBase64Srcs,
      existingGalleryFileNames: newExistingGalleryFileNames,
    };
  });
};

const handleMarkForDeletion = (index) => {
  const fileName = form.existingOtherFiles[index].fileName;
  setFilesToDelete(prev => [...prev, fileName]);

  setForm(prev => {
    const updated = [...prev.existingOtherFiles];
    updated.splice(index, 1);
    return { ...prev, existingOtherFiles: updated };
  });
};

const handleMarkNewFileForDeletion = (index) => {
  const file = form.otherFiles[index];
  setFilesToRemoveFromUpload(prev => [...prev, file]);

  setForm(prev => ({
    ...prev,
    otherFiles: prev.otherFiles.filter((_, i) => i !== index),
  }));
};

  const handleDeleteCategoryPhoto = async () => {
    if (form.existingCategoryFileName) {
      await deleteFiles(id, [form.existingCategoryFileName]);
      setForm(prev => ({
        ...prev,
        existingCategoryFileName: null,
      }));
    }
    setForm(prev => ({ ...prev, categoryPhoto: null }));
  };
  
// Delete new gallery photo (not uploaded yet)
const handleDeleteNewGalleryPhoto = (index) => {
  setForm(prev => ({
    ...prev,
    photos: prev.photos.filter((_, i) => i !== index),
  }));
};

  const handleOpenModal = (img) => {
    if (!img) return;
    setModalImage(typeof img === 'string' ? img : URL.createObjectURL(img));
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalImage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedAmenity = {
    name: form.name,
    description: form.description,
    categoryId: form.categoryId,
    phone: form.phone,
    email: form.email,
    websiteUrl: form.websiteUrl,
    providerId: form.providerId,
    location: {
      latitude: parseFloat(form.location.latitude),
      longitude: parseFloat(form.location.longitude),
   },
   status: 1
    };

    try {
      const response = await fetch(`${BASE_URL}Amenity/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenString}`,
        },
        body: JSON.stringify(updatedAmenity),
      });

      if (!response.ok) throw new Error('Failed to update Amenity');


if(response.ok){
      // Delete old cover photo if replacing
      if (form.coverPhoto && form.existingCoverFileName) {
        await deleteFiles(id, [form.existingCoverFileName]);
      }
      // Delete old category photo if replacing
      if (form.categoryPhoto && form.existingCategoryFileName) {
        await deleteFiles(id, [form.existingCategoryFileName]);
      }

      if (form.posterPhoto && form.existingPosterFileName) {
        await deleteFiles(id, [form.existingPosterFileName]);
      }

       if (filesToDelete.length > 0) {
         await deleteFiles(id, filesToDelete);
       }


      // Upload files
      const uploadFileList = [];
      const fileTypes = [];

     

      if (form.coverPhoto) {
        uploadFileList.push(form.coverPhoto);
        fileTypes.push(FILE_PLACE_TYPE.CoverPhoto);
      }
      if (form.categoryPhoto) {
        uploadFileList.push(form.categoryPhoto);
        fileTypes.push(FILE_PLACE_TYPE.CategoryPhoto);
      }

      if (form.posterPhoto) {
        uploadFileList.push(form.posterPhoto);
        fileTypes.push(FILE_PLACE_TYPE.Poster); // ✅ NEW
      }

      if (form.photos?.length > 0) {
        uploadFileList.push(...form.photos);
        fileTypes.push(...Array(form.photos.length).fill(FILE_PLACE_TYPE.Gallery));
      }


      if (form.otherFiles?.length > 0) {
        uploadFileList.push(...form.otherFiles);
        fileTypes.push(...Array(form.otherFiles.length).fill(FILE_PLACE_TYPE.Documents));
      }

      if (uploadFileList.length > 0) {
        await uploadFiles(id, uploadFileList, fileTypes);
  
      }
    

      alert(t('updatedSuccessfully'));
      navigate('/admin/amenities');
    }
    } catch (err) {
      console.error(err);
      alert(t('errorUpdatingAmenity'));
    }
  };


  const openPreview = (url) => {
  if (pdfPreviewUrl?.startsWith('blob:')) {
    URL.revokeObjectURL(pdfPreviewUrl);
  }
  if (isMobile) {
    window.open(url, '_blank');
  } else {
    setPdfPreviewUrl(url);
    setModalVisible(true);
  }
};

  if (!form) return <p>{t('loading')}...</p>;

  return (
    <Container>
      <TopBar>
        <BackButton onClick={() => navigate('/admin/amenities')}>
          ← {t('backToAmenities')}
        </BackButton>
        <Title>{t('editAmenity')}</Title>
      </TopBar>
      <form onSubmit={handleSubmit}>
        <FormWrapper>
          {['name', 'description'].map((field) => (
            <FieldWrapper key={field}>
              <FieldTitle>{t(field)}</FieldTitle>
              <LangRow>
                <FieldGroup>
                  <label>{t(field)} (Ελληνικά)</label>
                  {field === 'description' ? (
                    <textarea
                      value={form[field].gr}
                      onChange={(e) => handleChange(field, e.target.value, 'gr')}
                    />
                  ) : (
                    <input
                      type="text"
                      value={form[field].gr}
                      onChange={(e) => handleChange(field, e.target.value, 'gr')}
                    />
                  )}
                </FieldGroup>

                <FieldGroup>
                  <label>{t(field)} (English)</label>
                  {field === 'description' ? (
                    <textarea
                      value={form[field].en}
                      onChange={(e) => handleChange(field, e.target.value, 'en')}
                    />
                  ) : (
                    <input
                      type="text"
                      value={form[field].en}
                      onChange={(e) => handleChange(field, e.target.value, 'en')}
                    />
                  )}
                </FieldGroup>
              </LangRow>
            </FieldWrapper>
          ))}

          <FieldWrapper>
            <FieldTitle>{t('category')}</FieldTitle>
            <FieldGroup>
              <StyledSelect
                value={form.categoryId}
                onChange={(e) => handleChange('categoryId', e.target.value)}
                required
              >
                <option value="" disabled>
                  {t('selectCategory')}
                </option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name?.[i18n.language] || cat.name?.en}
                  </option>
                ))}
              </StyledSelect>
            </FieldGroup>
          </FieldWrapper>

        <FieldWrapper>
            <FieldTitle>{t("location")}</FieldTitle>
            <LocationPicker
              location={form.location}
              onChange={(loc) => handleChange("location", loc)}
              isLoaded={isLoaded}
            />
         </FieldWrapper>

        <FieldWrapper>
        <FieldTitle>{t('phone')}</FieldTitle>
        <FieldGroup>
          <PhoneInput
            international
            defaultCountry="GR"   
            value={form.phone}
            onChange={(value) => handleChange('phone', value)}
            required
            countryCallingCodeEditable={false}
            placeholder={t('enterPhone')}
          />
        </FieldGroup>
      </FieldWrapper>

      <FieldWrapper>
        <FieldTitle>{t('email')}</FieldTitle>
        <FieldGroup>
          <input
            type="email"
            value={form.email}
            onChange={(e) => handleChange('email', e.target.value)}
            required
          />
        </FieldGroup>
      </FieldWrapper>

      <FieldWrapper>
        <FieldTitle>{t('websiteUrl')}</FieldTitle>
        <FieldGroup>
          <input
            type="url"
            value={form.websiteUrl}
            onChange={(e) => handleChange('websiteUrl', e.target.value)}
            placeholder="https://example.com"
          />
        </FieldGroup>
      </FieldWrapper>

      <FieldWrapper>
        <FieldTitle>{t('providerName')}</FieldTitle>
        <FieldGroup>
            {form.providerName}
        </FieldGroup>
      </FieldWrapper>

      <FieldWrapper>
          <FieldTitle>{t('documents')}</FieldTitle>
          <FieldGroup>
             <input
              type="file"
              multiple
              accept=".pdf"
              onChange={(e) => {
                const files = Array.from(e.target.files);
                if (files.length > 0) {
                  setForm(prev => ({
                    ...prev,
                    otherFiles: [...(prev.otherFiles || []), ...files],
                  }));
                }
              }}
            />           
          </FieldGroup>

          {form.existingOtherFiles?.length > 0 && (
            <FileListContainer>
              {form.existingOtherFiles.map((file, index) => (
                <FileCard key={file.fileName}>
                  <FileInfo>
                    <span>{file.fileName}</span>
                  </FileInfo>
                  <FileActions>
                    <a
                      href={`data:${file.mimeType};base64,${file.base64Content}`}
                      // target="_blank"
                      // rel="noopener noreferrer"
                      
                      onClick={(e) => {
                         e.preventDefault();  
                        e.stopPropagation();
                        openPreview(`data:${file.mimeType};base64,${file.base64Content}`);
                      }}
                      title={t('preview')}
                    >
                      <FiFileText />
                    </a>
                    <a
                      href={`data:${file.mimeType};base64,${file.base64Content}`}
                      download={file.fileName}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={t('download')}
                    >
                      <FiDownload />
                    </a>
                    <button
                      className="delete"
                      type="button"
                      onClick={() => handleMarkForDeletion(index)}
                      title={t('delete')}
                    >
                      <FiTrash2 />
                    </button>
                  </FileActions>
                </FileCard>
              ))}
            </FileListContainer>
          )}
          
          {form.otherFiles?.length > 0 && (
            <FileListContainer>
              {form.otherFiles.map((file, index) => (
                <FileCard key={index}>
                  <FileInfo>
                    <span>{file.name}</span>
                  </FileInfo>
                  <FileActions>
                    <a
                      href={URL.createObjectURL(file)}
                      // target="_blank"
                      // rel="noopener noreferrer"
                      onClick={(e) => {
                         e.preventDefault(); 
                        e.stopPropagation();
                        openPreview(URL.createObjectURL(file));
                      }}
                      title={t('preview')}
                    >
                      <FiFileText />
                    </a>
          
                    <a
                      href={URL.createObjectURL(file)}
                      download={file.name}
                      title={t('download')}
                    >
                      <FiDownload />
                    </a>
                    <button
                      className="delete"
                      type="button"
                      onClick={() => handleMarkNewFileForDeletion(index)}
                      title={t('delete')}
                    >
                      <FiTrash2 />
                    </button>
                  </FileActions>
                </FileCard>
              ))}
            </FileListContainer>
          )}
         </FieldWrapper>


              <FieldWrapper>
            <FieldGroup>
            <FieldTitle>{t('categoryPhoto')}</FieldTitle>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, false, 'categoryPhoto')}
              required={!form.categoryPhoto && !form.existingCategoryFileName}
            />
            </FieldGroup>

              {isLoading ? (
                 <p>Loading...</p>
               ) : form.categoryPhoto || form.existingCategoryFileName ? (
                 <SinglePhotoContainer>
                   <img
                     src={
                       form.categoryPhoto
                         ? URL.createObjectURL(form.categoryPhoto)
                         : form.categoryBase64Src
                     }
                     alt="Category"
                     style={{ width: 120, height: 120, objectFit: 'cover', cursor: 'pointer' }}
                     onClick={() =>
                       handleOpenModal(
                         form.categoryPhoto
                           ? URL.createObjectURL(form.categoryPhoto)
                           : form.categoryBase64Src
                       )
                     }
                   />
                   <DeleteButton type="button" onClick={handleDeleteCategoryPhoto}>
                     {t('delete')}
                   </DeleteButton>
                 </SinglePhotoContainer>
               ) : (
                 <p>{t('noFiles')}</p> 
               )}
          </FieldWrapper> 
          
      

          {/* Gallery Photos */}
          <FieldWrapper>
            <FieldGroup>
            <FieldTitle>{t('photos')}</FieldTitle>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={(e) => handleFileChange(e, true, 'photos')}
            />
            </FieldGroup>
            

             {isLoading ? (
              <p>Loading...</p>
               ) : form.photos.length === 0 && (!form.galleryBase64Srcs || form.galleryBase64Srcs.length === 0) ? (
                 <p>{t('noFiles')}</p> 
               ) : (
              <PhotoGrid>
                {/* New gallery photos */}
                {form.photos.map((photo, index) => (
                  <PhotoItem key={`new-${index}`}>
                    <img
                      src={URL.createObjectURL(photo)}
                      alt={`Gallery new ${index}`}
                      style={{ width: 100, height: 100, objectFit: 'cover', cursor: 'pointer' }}
                      onClick={() => handleOpenModal(URL.createObjectURL(photo))}
                    />
                    <DeleteButton type="button" onClick={() => handleDeleteNewGalleryPhoto(index)}>
                      {t('delete')}
                    </DeleteButton>
                  </PhotoItem>
                ))}
          
                {/* Existing gallery photos */}
                {form.galleryBase64Srcs?.map((src, index) => (
                  <PhotoItem key={`existing-${index}`}>
                    <img
                      src={src}
                      alt={`Gallery existing ${index}`}
                      style={{ width: 100, height: 100, objectFit: 'cover', cursor: 'pointer' }}
                      onClick={() => handleOpenModal(src)}
                    />
                    <DeleteButton type="button" onClick={() => handleDeleteExistingGalleryPhoto(index)}>
                      {t('delete')}
                    </DeleteButton>
                  </PhotoItem>
                ))}
              </PhotoGrid>
            )}
          
  
          </FieldWrapper>



          <Button type="submit">{t('save')}</Button>
        </FormWrapper>
      </form>

    
      <Modal visible={showModal} onClick={handleCloseModal}>
        <ModalImage src={modalImage} alt="Full screen view" onClick={(e) => e.stopPropagation()} />
      </Modal>

      <Modal
        visible={modalVisible}
        onClick={() => {
          if (pdfPreviewUrl?.startsWith('blob:')) URL.revokeObjectURL(pdfPreviewUrl);
          setModalVisible(false);
          setPdfPreviewUrl(null);
        }}
      >
        {pdfPreviewUrl && (
          <iframe
            src={pdfPreviewUrl}
            title="PDF Preview"
            width="90%"
            height="90%"
            frameBorder="0"
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </Modal>
     
    </Container>
  );
};

export default EditAmenity;






